<div *ngIf="lists.length">
  <div class="wrapper-tab-lists">
    <div *ngFor="let list of lists" [routerLink]="[PAGES_AND_PATHS.singleList.pagePath, list.id, 'cards']"
         class="wrapper-list-preview">
      <div class="wrapper-image-list">
        <img [src]="list.lyst_image_url !== null ? list.lyst_image_url : 'assets/images/no-image.png'" alt="">
      </div>
      <div class="wrapper-info-list">
        <div class="title-list">
          <span>{{list | matchLocale}}</span>
          <span class="label-item">{{list.lyst_items_count}} {{list.lyst_items_count === 1 ? ('LISTS.items' | translate) : ('LISTS.items' | translate)}}</span>
        </div>
        <span class="time-list">{{list.created_at | timeAgo}}</span>
      </div>
    </div>
  </div>
  <button [routerLink]="PAGES_AND_PATHS.myLists.pagePath" class="custom-btn custom-btn--gray">
    <span>{{'NEW_TEXT.view_all_lists' | translate}}</span>
  </button>
</div>
<div *ngIf="!lists.length" class="no-data-box">
  <span>No data</span>
</div>
